/* unplugin-vue-components disabled */import { render } from "./TradingOrderList.vue?vue&type=template&id=57cdc3e7"
import script from "./TradingOrderList.vue?vue&type=script&lang=js"
export * from "./TradingOrderList.vue?vue&type=script&lang=js"

import "./TradingOrderList.vue?vue&type=style&index=0&id=57cdc3e7&lang=css"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__